/**
 *  Vanilla Proxy to 'pubsub-js' vendor
 *
 *  @link https://github.com/mroderick/PubSubJS
 */
// @ts-ignore: "pubsub-js" export not TypeScript compliant
import PubSub from 'pubsub-js'

/**
 * Subscribe to an event with a simplified callback that only receives the data.
 * @template T
 * @param {string} event - The event name to subscribe to
 * @param {(data: T) => void} callback - Callback that receives only the data payload
 * @returns {string} Subscription token for unsubscribing
 */
function subscribe(event, callback) {
  return PubSub.subscribe(event, (/** @type {string} */ _, /** @type {T} */ data) => callback(data))
}

const pubSub = {
  ...PubSub,
  subscribe
}

export default pubSub
